<template>
    <div>
        <div>
            <el-table  :data="user.tableData"
                :header-cell-style="{ 'text-align': 'center' }" v-loading="user.loading" stripe>
                <el-table-column prop="id" label="任务Id" align="center"></el-table-column>
                <el-table-column prop="taskMsg" label="任务数据" align="center"></el-table-column>
                <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
                <el-table-column prop="operation" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="showEditDialog(scope.row.id)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="user.pageIndex"
                    :page-size="user.pageSize" :total="user.pageTotal"
                    @current-change="handleUserPageChange"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { getTaskTimingList } from '../../api/timing.js'
export default {
    name: 'TaskTiming',
    data: function () {
        return {
            // 表格数据
            user: {
                tableData: [],
                pageIndex: 1,
                pageSize: 10,
                pageTotal: 1,
            },
        }
    },
    created() {
        this.initUserData()
    },
    activated() {
        this.initUserData()
    },
    methods: {
        //初始化数据
        initUserData() {
            //发送请求
            let params = { 'startPage': this.user.pageIndex, 'pageCount': this.user.pageSize }
            getTaskTimingList(params).then(res => {
                if (res.status == 200) {
                    this.user.tableData = res.data.data.records
                    this.user.pageTotal = res.data.data.total;
                }
                this.user.loading = false
            }).catch(err => {
                this.user.loading = false
            })
        },
        showEditDialog(id) {
            this.$router.push({
                path: "taskTimingModify",
                query: { taskid: id }
            });
        },

        //上一页 or 下一页
        handleUserPageChange(pageIndex) {
            this.user.pageIndex = pageIndex
            this.initUserData()
        },
    }
}
</script>

<style scoped lang="scss">
/* 鼠标悬浮 */
::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td {
    //  background-color: #212e3e !important;
    cursor: pointer;
}

.handle-input {
    width: 260px;
    display: inline-block;
    margin-right: 10px;
}
</style>
